import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { EquipmentStorageService } from "../storage/equipment-storage.service";
import { BaseDao } from "../../core/Dao/base.dao";
import { Equipment } from "../../models/equipment.model";
import { fetchChildrenEquipmentsRequest } from "../../models/fetch-request/fetch-children-equipments-request";

@Injectable({ providedIn: "root" })
export class EquipmentDao extends BaseDao<Equipment> {
  protected readonly storage = inject(EquipmentStorageService);

  protected override getUniqueKey(item: Equipment): string {
    return item.uniqueKeyIDInternal;
  }

  findChildren(parentAssetItemNumber: number): Observable<Equipment[]> {
    const request = fetchChildrenEquipmentsRequest(parentAssetItemNumber);
    return this.fetch(request);
  }
}
